/*!
 * CBD HUT — main-list-collections pagination (section-safe)
 * - Works on first load + Theme Editor section reloads
 * - Uses hidden attribute (clean + accessible)
 * - Reduced-motion friendly scroll
 */

(function () {
  'use strict';

  var INIT_ATTR = 'data-cbh-mlc-init';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(root) {
    if (!root || root.hasAttribute(INIT_ATTR)) return;
    root.setAttribute(INIT_ATTR, '1');

    var itemsPerPage = parseInt(root.getAttribute('data-items-per-page') || '0', 10);
    if (!itemsPerPage || itemsPerPage < 1) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-collection-item]'));
    var pagination = root.querySelector('[data-collection-pagination]');

    if (!items.length || !pagination) return;

    var currentPage = 1;

    root.setAttribute('data-cbh-mlc-ready', 'true');

    function scrollToTopOfSection() {
      var behaviour = prefersReducedMotion() ? 'auto' : 'smooth';
      requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: behaviour, block: 'start' });
      });
    }

    function renderPagination(totalPages) {
      pagination.innerHTML = '';

      if (totalPages <= 1) return;

      // Prev
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.textContent = '‹';
      prev.setAttribute('aria-label', 'Previous page');
      prev.disabled = currentPage === 1;
      prev.addEventListener('click', function () {
        renderPage(currentPage - 1, true);
      });
      pagination.appendChild(prev);

      // Numbered
      for (var i = 1; i <= totalPages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = String(i);

        if (i === currentPage) {
          btn.classList.add('active');
          btn.setAttribute('aria-current', 'page');
          btn.disabled = true; // prevents re-clicking current
        } else {
          btn.addEventListener('click', (function (page) {
            return function () { renderPage(page, true); };
          })(i));
        }

        pagination.appendChild(btn);
      }

      // Next
      var next = document.createElement('button');
      next.type = 'button';
      next.textContent = '›';
      next.setAttribute('aria-label', 'Next page');
      next.disabled = currentPage === totalPages;
      next.addEventListener('click', function () {
        renderPage(currentPage + 1, true);
      });
      pagination.appendChild(next);
    }

    function renderPage(page, doScroll) {
      var totalPages = Math.ceil(items.length / itemsPerPage);
      currentPage = Math.min(Math.max(1, page), totalPages);

      var start = (currentPage - 1) * itemsPerPage;
      var end = start + itemsPerPage;

      for (var i = 0; i < items.length; i++) {
        var show = (i >= start && i < end);
        items[i].toggleAttribute('hidden', !show);
      }

      renderPagination(totalPages);

      if (doScroll) scrollToTopOfSection();
    }

    // Initial render (no scroll)
    renderPage(1, false);
  }

  function initAll(context) {
    var scope = (context && context.querySelectorAll) ? context : document;
    var roots = scope.querySelectorAll('[data-cbh-main-list-collections]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  // First load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
